package com.eladfinish.bible.contest.analytics

import com.eladfinish.bible.contest.analytics.providers.AnalyticsProvider
import com.eladfinish.bible.contest.analytics.providers.provideAnalyticsProvider
import org.koin.dsl.module

val analyticsModule = module {
    single<AnalyticsProvider> { provideAnalyticsProvider() }
}
